import React, { useState } from 'react';
import { DailyReportCardLayout } from 'modules/components/layer05';
import { SaveDeliveryModal } from 'modules/components/layer17';
import { InstallationItem } from 'modules/components/layer19';
import { useAccessState } from 'modules/common';
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';

import * as ds from './dataService';


export type ReportDeliveryCardProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ReportDeliveryCardProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.installationId ?? '');

  const [fnRemoveDelivery] = ds.useRemoveDelivery();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const access = useAccessState('MaterialDelivery');

  return (
    <>
      {isVisible && (
        <SaveDeliveryModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <DailyReportCardLayout.FC
        title='Deliveries'
        subTitle='All of stuff delivered on site.'
        actionButton={{
          text: 'Add new delivery',
          onClick: () => {
            setIsVisible(() => true);
          },
          disabled: !access.create
        }}
      >
        {data.map((node, i) => (
          <InstallationItem.FC
            key={i}
            id={node.id}
            installationItemType='DELIVERY'
            title={node.name}
            disableEdit={!access.update}
            disableRemove={!access.delete}
            handleRemove={async () => await fnRemoveDelivery(node.id)}
          >
            <Typography
              variant='formLabel'
            >
              Delivered On:
            </Typography>

            <Typography
              variant='formInput'
            >
              {node.dateReceived?.toFormat('DDDD')}
            </Typography>

          </InstallationItem.FC>
        ))}

      </DailyReportCardLayout.FC>
    </>
  );
};
